import React, { useEffect, useState } from "react";
import { GetCountryIdFromName } from "../../../api/variablesController";
import { READ_ONLY_VARIABLE_NAME } from "../../../common/constants";
import {
	FilterType,
	Grid,
	MUIDataTable,
	SelectableRows,
} from "../../../common/MaterialComponent";
import Shared from "../../../common/shared";
import { useGetComponentStringsContext } from "../../../hooks/useGetComponentStrings";
import VariablesModel from "../../../models/Variables/VariablesModel";
import { ActionColumn } from "../ActionColumn/ActionColumn";
import { AddButton } from "../AddButton/AddButton";

export interface VariablesListDataGridProp {
	setVariablesUpdated: (flag: boolean) => void;
	variablesList: VariablesModel[];
	country: string;
}

export const VariablesListDataGrid: React.FC<VariablesListDataGridProp> = ({
	setVariablesUpdated,
	variablesList,
	country,
}) => {
	const [countryId, setCountryId] = useState(0);

	const strings = useGetComponentStringsContext().VariablesListDataGrid;

	useEffect(() => {
		const getCountryId = async () => {
			try {
				const res = await GetCountryIdFromName(country);
				if (res.error) {
					Shared.showSnackbarMessage("Failed to retrieve country Id");
				} else {
					setCountryId(res.responseObj ? res.responseObj : 0);
				}
			} catch (err) {
				console.error(err);
			}
		};
		if (country) {
			getCountryId();
		}
	}, [country]);

	const columns = [
		{
			name: "Name",
			label: strings.variableName,
			options: {
				filter: false,
			},
		},
		{
			name: "Value",
			label: strings.variableValue,
			options: {
				filter: false,
			},
		},
		{
			name: "Group",
			label: strings.variableGroup,
			options: {
				filterType: "dropdown" as FilterType,
			},
		},
		{
			name: "Action",
			label: strings.action,
			options: {
				filter: false,
				sort: false,
				empty: true,
				customBodyRender: (value: any, tableMeta: any) => {
					let editOnly = false;
					if (tableMeta.rowData[2] === READ_ONLY_VARIABLE_NAME) {
						editOnly = true;
					}
					return (
						<ActionColumn
							setVariablesUpdated={setVariablesUpdated}
							tableMeta={tableMeta}
							editOnly={editOnly}
							countryId={countryId}
						/>
					);
				},
			},
		},
	];

	const options = {
		print: false,
		selectableRows: "none" as SelectableRows,
		download: false,
		viewColumns: false,
		customToolbar: () => {
			return (
				<AddButton
					setVariablesUpdated={setVariablesUpdated}
					countryId={countryId}
				/>
			);
		},
	};

	return (
		<div>
			<Grid container spacing={3}>
				<Grid item xs={12} className="notificationList">
					<MUIDataTable
						title={`${strings.tableTitle} ${country}`}
						data={variablesList}
						columns={columns}
						options={options}
					/>
				</Grid>
			</Grid>
		</div>
	);
};
